import { paginateArtifactRows, type ArtifactPage, type ArtifactPageGroup, type MeasuredArtifactRow } from "./client-artifact-pages";

/** Compatibility seam: PoS keeps its three required consumer-owned sections. */
export type ProofSection = "coverage" | "exceptions" | "incidents";
export type MeasuredProofRow = MeasuredArtifactRow<ProofSection>;
export type ProofPageGroup = ArtifactPageGroup<ProofSection>;
export type ProofPage = ArtifactPage<ProofSection>;
export const paginateProofRows = paginateArtifactRows<ProofSection>;
